// extracted by mini-css-extract-plugin
export default {"button":"style_button__60RUK","indicator":"style_indicator__wxyrj","bg_main":"style_bg_main__cBLiq","bg_top":"style_bg_top__s+HVm"};